import { createFileRoute, redirect } from "@tanstack/react-router";

// /home is a permanent compatibility redirect to / preserving query/hash.
export const Route = createFileRoute("/home")({
  beforeLoad: ({ location }) => {
    throw redirect({
      to: "/",
      search: location.search,
      replace: true,
    });
  },
});
